var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

import React, { useEffect } from "react";
import createPersistedState from 'use-persisted-state';
import { useAppState } from "./use-app-state";
export var useVisibility = function useVisibility(name, persisted) {
  if (persisted === void 0) {
    persisted = true;
  }

  var _a = __read(useAppState(), 2),
      appState = _a[0],
      setAppState = _a[1];

  var usePersistedVisibilityState = createPersistedState(name);

  var _b = __read(usePersistedVisibilityState(), 2),
      persistedState = _b[0],
      setPersistedState = _b[1];

  var state = persisted ? persistedState : (appState || {})[name];
  var setState = persisted ? setPersistedState : function (val) {
    var _a;

    setAppState(__assign(__assign({}, appState || {}), (_a = {}, _a[name] = val, _a)));
  };
  var isVisible = state;

  var toggle = function toggle() {
    setState(!isVisible);
  };

  var show = function show() {
    setState(true);
  };

  var hide = function hide() {
    setState(false);
  };

  var useClickOutside = function useClickOutside() {
    var ref = React.useRef();
    useEffect(function () {
      var checkIfClickedOutside = function checkIfClickedOutside(e) {
        // If the item is open and the clicked target is not within the menu,
        // then close the menu
        // @ts-ignore
        if (isVisible && ref.current && !ref.current.contains(e.target)) {
          hide();
        }
      };

      document.addEventListener("click", checkIfClickedOutside);
      return function () {
        // Cleanup the event listener
        document.removeEventListener("click", checkIfClickedOutside);
      };
    }, [isVisible]);
    return ref;
  };

  return {
    toggle: toggle,
    show: show,
    hide: hide,
    toggleOnClick: function toggleOnClick(event) {
      toggle();
      event.stopPropagation();
    },
    showOnClick: function showOnClick(event) {
      show();
      event.stopPropagation();
    },
    hideOnClick: function hideOnClick(event) {
      hide();
      event.stopPropagation();
    },
    isVisible: isVisible,
    useClickOutside: useClickOutside
  };
};